import type { Logger } from "@expert/logging";
import type { GaiaBotMessage, ProactiveMessagePayload } from "@expert/shared-types";

import { trackFullStoryEvent } from "@expert/monitoring";
import { setRecommendation } from "@expert/solve-tools";
import { reactAnalytics } from "@soluto-private/eventualize-react";

export const handleGuidedFlowRecommendation = (msg: GaiaBotMessage, logger: Logger) => {
    const proactiveMessage = msg as ProactiveMessagePayload;
    const sessionId = proactiveMessage.sessionGroupId;
    const { cues, messageType } = proactiveMessage.suggestion;
    const name = cues?.[0]?.name;

    setRecommendation(logger, name);

    void reactAnalytics.dispatcher
        .withIdentities({
            ...(sessionId && { SessionId: sessionId }),
        })
        .dispatchBusinessEvent("Guide_SuggestionReceived", {
            callCategory: name,
            messageType,
            senderType: "bot",
        });
    trackFullStoryEvent("Guide_SuggestionReceived", {
        callCategory: name,
        messageType,
        sessionId,
    });
};
